import { ILocale } from '@move-frontend/contentful-routes';
import { contentful } from '../../../../shared/api/contentful';

export async function getSiteSections(locale: ILocale) {
	return contentful().siteSection().getAllForLocaleWithMenuItems(locale.code, {
		include: 3,
	});
}
